module.exports = __webpack_public_path__ + "img/tiananLOGO.7824a1a0.png";